/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Transcript_Preview_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Transcript Editor Preview for event {eventIndex}" |
*
* @param {Event_Transcript_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_transcript_preview_aria_label = /** @type {((inputs: Event_Transcript_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Transcript_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Apercu de l'editeur de transcription pour l'evenement ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorschau des Transkripteditors für Ereignis ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Anteprima dell'editor di trascrizione per l'evento ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предварительный просмотр стенограммы мероприятия ${i?.eventIndex} в редакторе.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Vista previa del editor de transcripciones para el evento ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`活动 ${i?.eventIndex} 的文字稿编辑器预览`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.eventIndex} のトランスクリプト エディター プレビュー`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.eventIndex} के लिए ट्रांसक्रिप्ट एडिटर का पूर्वावलोकन`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Pré-visualização do Editor de Transcrição para o evento ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Transcript Editor Preview for event ${i?.eventIndex}`)
});